<template>
  <v-text-field
    dense
    class="s-t-b text-search-field"
    outlined
    color="primary"
    hide-details
    :placeholder="$t(placeholder)"
    v-model="search"
    v-on:keyup.enter="searchPress(search)"
    v-on:click:clear="onClear()"
    clearable
  >
    <!-- search icon inside the input (same as the sale page header search) -->
    <template v-slot:append>
      <v-icon 
      small        
        class="text-search-icon"
        :aria-label="$t('search') || 'Search'"
        @click="searchPress(search)"
        >fal fa-search</v-icon
      >
    </template>
  </v-text-field>
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: {
      type: String,
      default: "search",
    },
  },
  data: () => ({
    search: "",
  }),
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.search = newVal;
    },
    search(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
  methods: {
    searchPress(search) {
      this.$emit("search", search);
    },
    onClear() {
      this.$emit("onClear");
      this.search = "";
      this.$emit("input", "");
    },
  },
};
</script>

<style scoped>
.text-search-field ::v-deep input {
  color: var(--v-text-base, rgba(0, 0, 0, 0.87));
}

.theme--dark.text-search-field ::v-deep input,
.theme--dark .text-search-field ::v-deep input {
  color: #f1f5f9 !important;
}

.text-search-field ::v-deep .v-input__append-inner {
  align-self: center;
  margin-top: 0 !important;
  display: flex;
  align-items: center;
  gap: 4px;
}

.text-search-field ::v-deep .v-input__icon {
  height: 24px;
  align-items: center;
}

.text-search-icon {
  cursor: pointer;
  transition: transform 0.15s ease;
}

.text-search-icon:hover {
  transform: scale(1.15);
}
</style>
